import { MdbRippleModule } from 'mdb-angular-ui-kit/ripple';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BillingItem } from './billing-cost-detailbreak.model';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { } from '@angular/common'; import { DataLayerService } from '@services/data-layer/data-layer.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, MdbRippleModule],
  selector: 'app-billing-cost-breakdown-new',
  providers: [CurrencyPipe],
  templateUrl: './billing-cost-breakdown-new.component.html',
  styleUrls: ['./billing-cost-breakdown-new.component.scss']
})
export class BillingCostBreakdownNewComponent implements OnInit, OnChanges {

  @Input() policy: any;
  schduledBillList: any[] = [];
  isAcmic: boolean;
  billingList: (BillingItem)[] = [];

  constructor(
    private acmicService: AcmicService,
    private currencyPipe: CurrencyPipe, private dataLayer: DataLayerService) {
    this.isAcmic = this.acmicService.isACMIC();
  }

  ngOnInit(): void {
    this.buildBillingList();
    if (window.innerWidth <= 991) {
      setTimeout(() => {
        this?.toggleBillingCost();
      });
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['policy'] && !changes['policy'].firstChange) {
      this.buildBillingList();
    }
  }

  private buildBillingList(): void {
    this.billingList = [];
    this.schduledBillList = this.policy.scheduleBills || [];
    this.schduledBillList.sort((a, b) => {
      return new Date(a.dateDue).getTime() - new Date(b.dateDue).getTime();
    });

    const isCancelledForPayment = this.policy.policyCancellationReason &&
      ['pay - non-payment of insurance premium', 'fpd - failure to pay deposit']
        .includes(this.policy.policyCancellationReason.toLowerCase());
    const canpremium = this.policy.exitDelinquencyAmount?.theAmount;
    if (isCancelledForPayment && canpremium > 0) {
      const policyCancellationDate = this.policy.policyCancellationEffectiveDate;
      this.billingList.push({
        date: this.policy.policyCancellationEffectiveDate,
        amount: this.currencyPipe.transform(
          this.policy.exitDelinquencyAmount.theAmount),
        status: this.getBillStatus(this.policy.policyCancellationEffectiveDate),
      });

      this.schduledBillList.forEach(scheduledBill => {
        if (!this.isPrior(scheduledBill.dateDue) &&
          !this.isPriorDate(scheduledBill.dateDue, policyCancellationDate)) {
          this.billingList.push({
            date: scheduledBill.dateDue,
            amount: this.currencyPipe.transform(
              scheduledBill.minAmountDue),
            status: this.getBillStatus(scheduledBill.dateDue),
          });
        }
      });

    } else {
      const minAmountDue = this.policy.billingDetails?.[0]?.minAmountDue ?? 0;
      const dueDate = this.policy.billingDetails?.[0]?.paymentDueDate;
      if (minAmountDue > 0) {
        this.billingList.push({
          date: dueDate,
          amount: this.currencyPipe.transform(
            minAmountDue),
          status: this.getBillStatus(dueDate),
        });
      }
      this.schduledBillList.forEach(scheduledBill => {
        if (scheduledBill.invoiceState != "Due") {
          const alreadyExists = this.billingList.some(bill => bill.date === scheduledBill.dateDue);
          if (!alreadyExists) {
            this.billingList.push({
              date: scheduledBill.dateDue,
              amount: this.currencyPipe.transform(
                scheduledBill.minAmountDue),
              status: this.getBillStatus(scheduledBill.dateDue),
            });
          }
        }
      });
    }
  }

  private getBillStatus(dateStr: string): string {
    const date = new Date(`${dateStr}T12:00:00`);;
    return this.isDateInCurrentMonth(date) ? 'current' : 'upcoming';
  }
  private isPrior(dateStr: string): boolean {
    const inputDate = new Date(dateStr);
    inputDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return inputDate < today;
  }

  private isPriorDate(dateStr: string, cancelDateStr: string): boolean {
    const inputDate = new Date(dateStr);
    inputDate.setHours(0, 0, 0, 0);
    const today = new Date(cancelDateStr);
    today.setHours(0, 0, 0, 0);
    return inputDate < today;
  }

  isDateInCurrentMonth(dateToCheck: Date): boolean {
    const currentDate = new Date();
    return (
      dateToCheck.getMonth() === currentDate.getMonth() &&
      dateToCheck.getFullYear() === currentDate.getFullYear()
    );
  }

  addOrRemoveClass(titleElement, typeOfClass) {
    if (titleElement && !titleElement.classList.contains(typeOfClass)) {
      titleElement.classList.add(typeOfClass);
    } else {
      titleElement.classList?.remove(typeOfClass);
    }
  }

  toggleCoverageCollapse() {
    const titleElement = document.getElementById('billcostbreaddownheader');
    this?.addOrRemoveClass(titleElement, 'active');

    const breakdownstatusEle = document.getElementById('breakdownstatus');
    this?.addOrRemoveClass(breakdownstatusEle, 'active');


    if (breakdownstatusEle.classList.contains("active")) {
      const event = {
        name: 'click_link',
        category: 'remarked content',
        detail: 'click banner',
        label: 'Show billing schedule'
      }
      this.dataLayer.pushEvent(event);
      breakdownstatusEle.textContent = "Show billing schedule";
    } else {
      breakdownstatusEle.textContent = "Hide billing schedule";
    }

    const titleEle = document.getElementById('billcostbreakdowntitle');
    this.addOrRemoveClass(titleEle, 'hidden');

    const element = document.getElementById('billcostbreakdown');
    this.addOrRemoveClass(element, 'hidden');
  }
  public toggleBillingCost() {
    this.toggleCoverageCollapse();
  }

}
